import request from '@/axios'

/** 文件系统临时凭证（对应后端 FileSystemTempModel） */
export interface FileSystemTempModel {
  /** OSS类型 1阿里云 2华为云 3天翼云 */
  type: number
  accessKeyId: string
  accessKeySecret: string
  securityToken: string
  endPoint: string
  bucketName: string
  httpUrl: string
}

/**
 * 获取云存储上传临时凭证
 * GET /SystemSet/FileSystem/GetToken
 */
export const getFileSystemTokenApi = (): Promise<IResponse<FileSystemTempModel>> => {
  return request.get({ url: '/SystemSet/FileSystem/GetToken' })
}
